var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('span',[_vm._t("default"),_c('el-cascader',{ref:"cascaderCase",staticClass:"aaa",class:{ last: _vm.isLast },style:(_vm.cssVars),attrs:{"popper-class":_vm.takeOut,"options":_vm.options,"show-all-levels":false,"placeholder":_vm.placeholder,"collapse-tags":_vm.collapsetags,"props":{
        expandTrigger: 'hover',
        checkStrictly: _vm.checkStrictly,
        multiple: _vm.multiple,
      }},on:{"change":_vm.handleChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }